// WHY THERE IS NO SELECTION - recorded, not guessed.
//
// A day went into a bug whose whole footprint was two branches that set
// null and told nobody (leader, 2026-09-20). The page can decide "no
// rule" for six different reasons and, until now, five of them looked
// identical from outside: nothing highlighted.
//
// So every branch that ends without a rule records WHICH branch it was,
// and every resolution records whether its answer was used or superseded.
// It is a ring buffer on window, read by root-f5's harness beside their
// store.selectionDiag (which records what the STAGE received - this
// records what the PAGE decided, and the pair tells you which half lost
// the answer).
//
//   trace('resolve:start', { keys: 2, seq: 7 })
//   trace('resolve:superseded', { seq: 7, latest: 8 })   <- knowingly dropped
//   window.__trackingSelection.rows        the last 60, newest last
//   window.__trackingSelection.last        the newest
const MAX = 60;
const rows = [];

export function trace(phase, detail = {}) {
  const row = { t: Date.now(), phase, ...detail };
  rows.push(row);
  if (rows.length > MAX) rows.shift();
  try {
    if (typeof window !== "undefined") {
      window.__trackingSelection = window.__trackingSelection || {};
      window.__trackingSelection.rows = rows;
      window.__trackingSelection.last = row;
    }
  } catch (e) { /* a diagnostic must never break the page */ }
  return row;
}

// What the harness asks for: the last outcome per phase, so three runs can
// be compared without reading sixty rows.
export function summary() {
  const out = {};
  for (const r of rows) out[r.phase] = r;
  return out;
}

export const traceRows = () => rows.slice();
export const clearTrace = () => { rows.length = 0; };
